export const getHeaders = (token) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Token ${token}`);
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Accept", "*/*");
  return myHeaders;
};
